import { render } from "./FloorplanView.vue?vue&type=template&id=ac824512"
import script from "./FloorplanView.vue?vue&type=script&lang=js"
export * from "./FloorplanView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/Upwork/kaz/plus studio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__